import * as React from 'react';
import { Jumbotron } from 'reactstrap';
import { compose, setDisplayName } from 'recompose';
import { AthleteProps } from '../types';
import withAthlete from '../withAthlete';
import './AthleteDetails.scss';

const enhance = compose<AthleteProps, any>(
    withAthlete,
    setDisplayName('AthleteDetails')
);

const AthleteDetails = ({ loggedInUser, error, loading }: AthleteProps) => {
    const user = loggedInUser && loggedInUser.user;
    const profile = user && user.athlete ? user.athlete.profile : '';

    return (
        <Jumbotron className="athlete-details">
            <div className="image-cropper">
                {profile ? (
                    <img
                        alt={`Profile image for ${
                            user ? user.name : 'current user'
                        }`}
                        src={profile}
                    />
                ) : null}
            </div>
            <h1>{user ? user.name : ''}</h1>
            <p className="lead">
                Click on the activities below to see the charts
            </p>
            {user && user.appStatus ? (
                <p className="text-muted small">{user.appStatus}</p>
            ) : null}
        </Jumbotron>
    );
};

export default enhance(AthleteDetails);



// WEBPACK FOOTER //
// ./src/client/components/Strava/ActivityListScene/AthleteDetails.tsx